import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import React from 'react';

import LocationImage from 'app/components/locations/LocationImage';
import LocationItemInfo from '../LocationItemInfo/LocationItemInfo';

import './LocationItem.scss';

export default function LocationItem({ location, preferred }) {
  return (
    <div className="cp-location-item">
      <LocationImage location={location} />
      <div className="location-details">
        <LocationItemInfo location={location} preferred={preferred} />
      </div>
    </div>
  );
}

LocationItem.propTypes = {
  location: ImmutablePropTypes.map.isRequired,
  preferred: PropTypes.bool
};
